/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { ElementRef, Directive, Renderer2, HostListener, AfterViewInit, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
@Directive({
    selector: '[nvEllipsifiedTextWithTooltip]',
    standalone: true,
    providers: [MatTooltip]
})
export class EllipsifiedTextWithTooltipDirective implements AfterViewInit, OnInit {
    private domElement: HTMLElement;
    @Input()
    public tooltipClass: string;
    @Input()
    public isTooltipEnabled = true;

    @Input()
    public applyEllipsisStyles = true;

    @Input()
    public isMultiLineEllipsis = false;

    @Input()
    public lineClamp: number;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        private matTooltip: MatTooltip
    ) {}

    ngOnInit() {
        this.domElement = this.elementRef.nativeElement;
        if (!this.applyEllipsisStyles) {
            return;
        }
        if (this.isMultiLineEllipsis) {
            this.renderer.addClass(this.domElement, 'multi-line-ellipsis');
        } else {
            this.renderer.addClass(this.domElement, 'single-line-ellipsis');
        }
        this.renderer.addClass(this.domElement, 'ellipsified-text-with-tooltip');
        if (this.lineClamp) {
            this.renderer.setStyle(this.domElement, '-webkit-line-clamp', this.lineClamp);
        }
    }

    ngAfterViewInit() {
        this.matTooltip.tooltipClass = this.tooltipClass;
    }

    @HostListener('mouseover')
    onMouseOver() {
        const isOverflow = this.isMultiLineEllipsis
            ? this.domElement.offsetHeight < this.domElement.scrollHeight
            : this.domElement.offsetWidth < this.domElement.scrollWidth;

        if (this.isTooltipEnabled && isOverflow) {
            this.matTooltip.message = this.domElement.innerText;
            this.matTooltip.show();
        }
    }

    @HostListener('mouseout')
    onMouseOut() {
        this.matTooltip.hide();
    }
}
